@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_087_886_853)
public val Res.string.report_col_day: StringResource by lazy {
      StringResource("string:report_col_day", "report_col_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 233962, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 332622, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213849, 26),
      ))
    }

@delegate:ResourceContentHash(3_563_342)
public val Res.string.report_col_hours: StringResource by lazy {
      StringResource("string:report_col_hours", "report_col_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 233993, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 332657, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213876, 32),
      ))
    }

@delegate:ResourceContentHash(-801_603_080)
public val Res.string.report_col_manager_signature: StringResource by lazy {
      StringResource("string:report_col_manager_signature", "report_col_manager_signature", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234030, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 332698, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213909, 64),
      ))
    }

@delegate:ResourceContentHash(1_645_318_585)
public val Res.string.report_col_night: StringResource by lazy {
      StringResource("string:report_col_night", "report_col_night", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234091, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 332779, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213974, 32),
      ))
    }

@delegate:ResourceContentHash(-807_143_046)
public val Res.string.report_col_notes: StringResource by lazy {
      StringResource("string:report_col_notes", "report_col_notes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234124, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 332820, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214007, 32),
      ))
    }

@delegate:ResourceContentHash(2_005_425_973)
public val Res.string.report_col_planned: StringResource by lazy {
      StringResource("string:report_col_planned", "report_col_planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234157, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 332869, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214040, 38),
      ))
    }

@delegate:ResourceContentHash(-811_018_599)
public val Res.string.report_contract: StringResource by lazy {
      StringResource("string:report_contract", "report_contract", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234192, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 332908, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214079, 35),
      ))
    }

@delegate:ResourceContentHash(1_526_181_073)
public val Res.string.report_employee: StringResource by lazy {
      StringResource("string:report_employee", "report_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234224, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 332952, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214115, 35),
      ))
    }

@delegate:ResourceContentHash(1_816_331_262)
public val Res.string.report_employer: StringResource by lazy {
      StringResource("string:report_employer", "report_employer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234260, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 333000, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214151, 35),
      ))
    }

@delegate:ResourceContentHash(-1_915_472_822)
public val Res.string.report_generated: StringResource by lazy {
      StringResource("string:report_generated", "report_generated", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234300, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 333056, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214187, 60),
      ))
    }

@delegate:ResourceContentHash(-962_459_850)
public val Res.string.report_holiday: StringResource by lazy {
      StringResource("string:report_holiday", "report_holiday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234365, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 333125, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214248, 42),
      ))
    }

@delegate:ResourceContentHash(3_563_342)
public val Res.string.report_hours_worked: StringResource by lazy {
      StringResource("string:report_hours_worked", "report_hours_worked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234400, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 333184, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214291, 35),
      ))
    }

@delegate:ResourceContentHash(-809_964_435)
public val Res.string.report_month: StringResource by lazy {
      StringResource("string:report_month", "report_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234440, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 333228, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214327, 28),
      ))
    }

@delegate:ResourceContentHash(-383_917_645)
public val Res.string.report_night_hours: StringResource by lazy {
      StringResource("string:report_night_hours", "report_night_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234473, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 333265, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214356, 42),
      ))
    }

@delegate:ResourceContentHash(-692_871_342)
public val Res.string.report_norm: StringResource by lazy {
      StringResource("string:report_norm", "report_norm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234532, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 333324, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214399, 59),
      ))
    }

@delegate:ResourceContentHash(1_355_856_895)
public val Res.string.report_payroll_title: StringResource by lazy {
      StringResource("string:report_payroll_title", "report_payroll_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234596, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 333428, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214459, 56),
      ))
    }

@delegate:ResourceContentHash(350_621_510)
public val Res.string.report_payslip_title: StringResource by lazy {
      StringResource("string:report_payslip_title", "report_payslip_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234657, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 333533, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214516, 44),
      ))
    }

@delegate:ResourceContentHash(1_632_718_782)
public val Res.string.report_plan_vs_actual: StringResource by lazy {
      StringResource("string:report_plan_vs_actual", "report_plan_vs_actual", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234718, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 333606, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214561, 49),
      ))
    }

@delegate:ResourceContentHash(-1_089_196_751)
public val Res.string.report_planned_only: StringResource by lazy {
      StringResource("string:report_planned_only", "report_planned_only", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234772, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 333664, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214611, 63),
      ))
    }

@delegate:ResourceContentHash(717_074_590)
public val Res.string.report_role: StringResource by lazy {
      StringResource("string:report_role", "report_role", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234856, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 333780, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214675, 31),
      ))
    }

@delegate:ResourceContentHash(-758_577_365)
public val Res.string.report_rounding_nearest: StringResource by lazy {
      StringResource("string:report_rounding_nearest", "report_rounding_nearest", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234892, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 333816, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214707, 59),
      ))
    }

@delegate:ResourceContentHash(166_159_759)
public val Res.string.report_rounding_note: StringResource by lazy {
      StringResource("string:report_rounding_note", "report_rounding_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 234960, 160),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 333908, 248),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214767, 172),
      ))
    }

@delegate:ResourceContentHash(-594_794_567)
public val Res.string.report_rounding_start_down_end_up: StringResource by lazy {
      StringResource("string:report_rounding_start_down_end_up", "report_rounding_start_down_end_up", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 235121, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 334157, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214940, 65),
      ))
    }

@delegate:ResourceContentHash(-1_018_320_648)
public val Res.string.report_rounding_start_up_end_down: StringResource by lazy {
      StringResource("string:report_rounding_start_up_end_down", "report_rounding_start_up_end_down", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 235211, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 334259, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215006, 65),
      ))
    }

@delegate:ResourceContentHash(-1_884_359_953)
public val Res.string.report_sign_employee: StringResource by lazy {
      StringResource("string:report_sign_employee", "report_sign_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 235301, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 334361, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215072, 52),
      ))
    }

@delegate:ResourceContentHash(-1_958_732_871)
public val Res.string.report_sign_employer: StringResource by lazy {
      StringResource("string:report_sign_employer", "report_sign_employer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 235354, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 334434, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215125, 52),
      ))
    }

@delegate:ResourceContentHash(-720_445_614)
public val Res.string.report_sunday: StringResource by lazy {
      StringResource("string:report_sunday", "report_sunday", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 235483, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 334607, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215246, 29),
      ))
    }

@delegate:ResourceContentHash(1_332_438_261)
public val Res.string.report_sunday_holiday_hours: StringResource by lazy {
      StringResource("string:report_sunday_holiday_hours", "report_sunday_holiday_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 235407, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 334511, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215178, 67),
      ))
    }

@delegate:ResourceContentHash(-1_641_193_974)
public val Res.string.report_total: StringResource by lazy {
      StringResource("string:report_total", "report_total", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 235572, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 334724, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215319, 28),
      ))
    }

@delegate:ResourceContentHash(-70_284_061)
public val Res.string.report_total_hours: StringResource by lazy {
      StringResource("string:report_total_hours", "report_total_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 235517, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 334645, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215276, 42),
      ))
    }

@delegate:ResourceContentHash(-399_447_246)
public val Res.string.report_working_time_title: StringResource by lazy {
      StringResource("string:report_working_time_title", "report_working_time_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 235601, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 334761, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215348, 61),
      ))
    }

@delegate:ResourceContentHash(1_063_749_081)
public val Res.string.report_workplace: StringResource by lazy {
      StringResource("string:report_workplace", "report_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 235663, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 334843, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215410, 36),
      ))
    }

@delegate:ResourceContentHash(-875_726_622)
public val Res.string.request_approve_now: StringResource by lazy {
      StringResource("string:request_approve_now", "request_approve_now", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 235696, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 334884, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215447, 43),
      ))
    }

@delegate:ResourceContentHash(1_623_153_920)
public val Res.string.request_blocks_no: StringResource by lazy {
      StringResource("string:request_blocks_no", "request_blocks_no", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 235822, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 335066, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215569, 65),
      ))
    }

@delegate:ResourceContentHash(1_798_749_110)
public val Res.string.request_blocks_no_for: StringResource by lazy {
      StringResource("string:request_blocks_no_for", "request_blocks_no_for", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 235748, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 334956, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215491, 77),
      ))
    }

@delegate:ResourceContentHash(-698_028_715)
public val Res.string.request_blood_date: StringResource by lazy {
      StringResource("string:request_blood_date", "request_blood_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 235892, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 335176, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215635, 46),
      ))
    }

@delegate:ResourceContentHash(-2_099_364_940)
public val Res.string.request_choose_type: StringResource by lazy {
      StringResource("string:request_choose_type", "request_choose_type", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 235943, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 335243, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215682, 59),
      ))
    }

@delegate:ResourceContentHash(879_716_839)
public val Res.string.request_date: StringResource by lazy {
      StringResource("string:request_date", "request_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236003, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 335315, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215742, 28),
      ))
    }

@delegate:ResourceContentHash(1_349_960_520)
public val Res.string.request_end_time: StringResource by lazy {
      StringResource("string:request_end_time", "request_end_time", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236032, 28),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 335348, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215771, 28),
      ))
    }

@delegate:ResourceContentHash(-1_204_122_961)
public val Res.string.request_for_person: StringResource by lazy {
      StringResource("string:request_for_person", "request_for_person", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236061, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 335381, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215800, 38),
      ))
    }

@delegate:ResourceContentHash(-2_086_012_327)
public val Res.string.request_group_family: StringResource by lazy {
      StringResource("string:request_group_family", "request_group_family", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236100, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 335424, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215839, 48),
      ))
    }

@delegate:ResourceContentHash(-1_170_991_031)
public val Res.string.request_group_health: StringResource by lazy {
      StringResource("string:request_group_health", "request_group_health", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236153, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 335493, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215888, 36),
      ))
    }

@delegate:ResourceContentHash(-2_002_082_475)
public val Res.string.request_group_leave: StringResource by lazy {
      StringResource("string:request_group_leave", "request_group_leave", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236194, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 335546, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215925, 51),
      ))
    }

@delegate:ResourceContentHash(-1_763_527_775)
public val Res.string.request_group_work: StringResource by lazy {
      StringResource("string:request_group_work", "request_group_work", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236250, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 335634, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215977, 34),
      ))
    }

@delegate:ResourceContentHash(-987_479_231)
public val Res.string.request_hours_value: StringResource by lazy {
      StringResource("string:request_hours_value", "request_hours_value", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236285, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 335677, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216012, 51),
      ))
    }

@delegate:ResourceContentHash(1_171_457_292)
public val Res.string.request_limit_blood: StringResource by lazy {
      StringResource("string:request_limit_blood", "request_limit_blood", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236337, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 335729, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216064, 55),
      ))
    }

@delegate:ResourceContentHash(289_396_493)
public val Res.string.request_limit_days_year: StringResource by lazy {
      StringResource("string:request_limit_days_year", "request_limit_days_year", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236409, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 335821, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216120, 47),
      ))
    }

@delegate:ResourceContentHash(115_916_075)
public val Res.string.request_limit_hours_year: StringResource by lazy {
      StringResource("string:request_limit_hours_year", "request_limit_hours_year", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236457, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 335881, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216168, 52),
      ))
    }

@delegate:ResourceContentHash(799_406_068)
public val Res.string.request_limit_less: StringResource by lazy {
      StringResource("string:request_limit_less", "request_limit_less", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236518, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 335954, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216221, 42),
      ))
    }

@delegate:ResourceContentHash(-1_520_555_694)
public val Res.string.request_limit_more: StringResource by lazy {
      StringResource("string:request_limit_more", "request_limit_more", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236561, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 336005, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216264, 42),
      ))
    }

@delegate:ResourceContentHash(-553_273_141)
public val Res.string.request_not_offered: StringResource by lazy {
      StringResource("string:request_not_offered", "request_not_offered", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236720, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 336204, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216431, 107),
      ))
    }

@delegate:ResourceContentHash(-277_341_553)
public val Res.string.request_not_offered_for: StringResource by lazy {
      StringResource("string:request_not_offered_for", "request_not_offered_for", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236608, 111),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 336056, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216307, 123),
      ))
    }

@delegate:ResourceContentHash(-1_796_042_477)
public val Res.string.request_others: StringResource by lazy {
      StringResource("string:request_others", "request_others", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236828, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 336356, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216539, 30),
      ))
    }

@delegate:ResourceContentHash(-397_140_933)
public val Res.string.request_part_of_day: StringResource by lazy {
      StringResource("string:request_part_of_day", "request_part_of_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236867, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 336391, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216570, 55),
      ))
    }

@delegate:ResourceContentHash(-16_125_125)
public val Res.string.request_pay_employer: StringResource by lazy {
      StringResource("string:request_pay_employer", "request_pay_employer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 237021, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 336629, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216704, 56),
      ))
    }

@delegate:ResourceContentHash(-44_369_617)
public val Res.string.request_pay_employer_half: StringResource by lazy {
      StringResource("string:request_pay_employer_half", "request_pay_employer_half", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 236931, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 336475, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216626, 77),
      ))
    }

@delegate:ResourceContentHash(-90_028_695)
public val Res.string.request_pay_none: StringResource by lazy {
      StringResource("string:request_pay_none", "request_pay_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 237086, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 336710, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216761, 32),
      ))
    }

@delegate:ResourceContentHash(-2_004_913_482)
public val Res.string.request_pay_overtime: StringResource by lazy {
      StringResource("string:request_pay_overtime", "request_pay_overtime", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 237127, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 336767, 168),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216794, 92),
      ))
    }

@delegate:ResourceContentHash(1_177_356_779)
public val Res.string.request_pay_sick: StringResource by lazy {
      StringResource("string:request_pay_sick", "request_pay_sick", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 237220, 120),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 336936, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216887, 124),
      ))
    }

@delegate:ResourceContentHash(-1_647_000_645)
public val Res.string.request_pay_work: StringResource by lazy {
      StringResource("string:request_pay_work", "request_pay_work", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 237341, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 337101, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217012, 60),
      ))
    }

@delegate:ResourceContentHash(674_264_093)
public val Res.string.request_pay_zus: StringResource by lazy {
      StringResource("string:request_pay_zus", "request_pay_zus", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 237406, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 337218, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217073, 103),
      ))
    }

@delegate:ResourceContentHash(427_784_645)
public val Res.string.request_place_label: StringResource by lazy {
      StringResource("string:request_place_label", "request_place_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 237506, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 337378, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217177, 55),
      ))
    }

@delegate:ResourceContentHash(-158_444_653)
public val Res.string.request_place_optional: StringResource by lazy {
      StringResource("string:request_place_optional", "request_place_optional", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 237570, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 337454, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217233, 54),
      ))
    }

@delegate:ResourceContentHash(40_773_886)
public val Res.string.request_popular: StringResource by lazy {
      StringResource("string:request_popular", "request_popular", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 237629, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 337541, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217288, 35),
      ))
    }

@delegate:ResourceContentHash(-655_315_788)
public val Res.string.request_short_half: StringResource by lazy {
      StringResource("string:request_short_half", "request_short_half", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 237685, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 337613, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217324, 42),
      ))
    }

@delegate:ResourceContentHash(1_438_334_361)
public val Res.string.request_short_line: StringResource by lazy {
      StringResource("string:request_short_line", "request_short_line", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 237732, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 337664, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217367, 42),
      ))
    }

@delegate:ResourceContentHash(-106_167_725)
public val Res.string.request_short_unpaid: StringResource by lazy {
      StringResource("string:request_short_unpaid", "request_short_unpaid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 237775, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 337707, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217410, 36),
      ))
    }

@delegate:ResourceContentHash(1_131_414_430)
public val Res.string.request_short_zus: StringResource by lazy {
      StringResource("string:request_short_zus", "request_short_zus", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 237820, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 337764, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217447, 41),
      ))
    }

@delegate:ResourceContentHash(848_877_804)
public val Res.string.request_start_time: StringResource by lazy {
      StringResource("string:request_start_time", "request_start_time", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 237862, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 337814, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217489, 34),
      ))
    }

@delegate:ResourceContentHash(-1_064_525_072)
public val Res.string.request_type_available_for: StringResource by lazy {
      StringResource("string:request_type_available_for", "request_type_available_for", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 237893, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 337849, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217524, 66),
      ))
    }

@delegate:ResourceContentHash(-1_468_426_160)
public val Res.string.request_type_contracts_none: StringResource by lazy {
      StringResource("string:request_type_contracts_none", "request_type_contracts_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 237956, 127),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 337944, 179),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217591, 107),
      ))
    }

@delegate:ResourceContentHash(-1_488_824_420)
public val Res.string.request_type_enabled: StringResource by lazy {
      StringResource("string:request_type_enabled", "request_type_enabled", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 238084, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 338124, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217699, 64),
      ))
    }

@delegate:ResourceContentHash(-897_900_681)
public val Res.string.request_type_limits: StringResource by lazy {
      StringResource("string:request_type_limits", "request_type_limits", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 238153, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 338217, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217764, 51),
      ))
    }

@delegate:ResourceContentHash(1_666_921_433)
public val Res.string.request_type_open: StringResource by lazy {
      StringResource("string:request_type_open", "request_type_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 238225, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 338313, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217816, 45),
      ))
    }

@delegate:ResourceContentHash(187_626_608)
public val Res.string.request_type_own_contracts: StringResource by lazy {
      StringResource("string:request_type_own_contracts", "request_type_own_contracts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 238275, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 338379, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217862, 66),
      ))
    }

@delegate:ResourceContentHash(-1_399_376_729)
public val Res.string.request_type_pay: StringResource by lazy {
      StringResource("string:request_type_pay", "request_type_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 238338, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 338470, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217929, 28),
      ))
    }

@delegate:ResourceContentHash(453_364_461)
public val Res.string.request_types_all_contracts: StringResource by lazy {
      StringResource("string:request_types_all_contracts", "request_types_all_contracts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 238383, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 338511, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217958, 55),
      ))
    }

@delegate:ResourceContentHash(-548_202_391)
public val Res.string.request_types_dialog_hint: StringResource by lazy {
      StringResource("string:request_types_dialog_hint", "request_types_dialog_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 238439, 333),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 338579, 545),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218014, 249),
      ))
    }

@delegate:ResourceContentHash(-1_204_122_961)
public val Res.string.request_types_for: StringResource by lazy {
      StringResource("string:request_types_for", "request_types_for", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 238773, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 339125, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218264, 37),
      ))
    }

@delegate:ResourceContentHash(-188_200_863)
public val Res.string.request_types_group_labour_code: StringResource by lazy {
      StringResource("string:request_types_group_labour_code", "request_types_group_labour_code", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 238811, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 339167, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218302, 75),
      ))
    }

@delegate:ResourceContentHash(-1_957_555_070)
public val Res.string.request_types_group_occasions: StringResource by lazy {
      StringResource("string:request_types_group_occasions", "request_types_group_occasions", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 238883, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 339283, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218378, 81),
      ))
    }

@delegate:ResourceContentHash(1_873_498_609)
public val Res.string.request_types_group_sickness: StringResource by lazy {
      StringResource("string:request_types_group_sickness", "request_types_group_sickness", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 238961, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 339401, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218460, 72),
      ))
    }

@delegate:ResourceContentHash(-1_032_195_215)
public val Res.string.request_types_group_unpaid: StringResource by lazy {
      StringResource("string:request_types_group_unpaid", "request_types_group_unpaid", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 239030, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 339494, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218533, 50),
      ))
    }

@delegate:ResourceContentHash(1_718_551_813)
public val Res.string.request_types_more: StringResource by lazy {
      StringResource("string:request_types_more", "request_types_more", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 239089, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 339589, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218584, 46),
      ))
    }

@delegate:ResourceContentHash(-113_204_681)
public val Res.string.request_types_no_contract: StringResource by lazy {
      StringResource("string:request_types_no_contract", "request_types_no_contract", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 239136, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 339632, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218631, 57),
      ))
    }

@delegate:ResourceContentHash(1_024_900_546)
public val Res.string.request_types_none_on: StringResource by lazy {
      StringResource("string:request_types_none_on", "request_types_none_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 239206, 145),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 339734, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218689, 121),
      ))
    }

@delegate:ResourceContentHash(-1_073_780_139)
public val Res.string.request_types_restore: StringResource by lazy {
      StringResource("string:request_types_restore", "request_types_restore", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 239815, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 340707, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219246, 57),
      ))
    }

@delegate:ResourceContentHash(1_513_051_721)
public val Res.string.request_types_restore_text: StringResource by lazy {
      StringResource("string:request_types_restore_text", "request_types_restore_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 239352, 382),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 339936, 638),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218811, 354),
      ))
    }

@delegate:ResourceContentHash(959_889_958)
public val Res.string.request_types_restore_title: StringResource by lazy {
      StringResource("string:request_types_restore_title", "request_types_restore_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 239735, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 340575, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219166, 79),
      ))
    }

@delegate:ResourceContentHash(-1_614_510_662)
public val Res.string.request_types_state: StringResource by lazy {
      StringResource("string:request_types_state", "request_types_state", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 240083, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 341095, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219510, 47),
      ))
    }

@delegate:ResourceContentHash(1_993_819_920)
public val Res.string.request_types_state_custom: StringResource by lazy {
      StringResource("string:request_types_state_custom", "request_types_state_custom", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 239873, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 340797, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219304, 58),
      ))
    }

@delegate:ResourceContentHash(1_123_733_150)
public val Res.string.request_types_state_legacy: StringResource by lazy {
      StringResource("string:request_types_state_legacy", "request_types_state_legacy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 239932, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 340884, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219363, 78),
      ))
    }

@delegate:ResourceContentHash(-1_418_840_422)
public val Res.string.request_types_state_recommended: StringResource by lazy {
      StringResource("string:request_types_state_recommended", "request_types_state_recommended", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 240015, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 340987, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219442, 67),
      ))
    }

@delegate:ResourceContentHash(-258_594_965)
public val Res.string.request_unit_days: StringResource by lazy {
      StringResource("string:request_unit_days", "request_unit_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 240135, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 341147, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219558, 49),
      ))
    }

@delegate:ResourceContentHash(-1_639_577_610)
public val Res.string.request_unit_fixed_days: StringResource by lazy {
      StringResource("string:request_unit_fixed_days", "request_unit_fixed_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 240193, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 341213, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219608, 71),
      ))
    }

@delegate:ResourceContentHash(1_692_949_122)
public val Res.string.request_unit_fixed_hours: StringResource by lazy {
      StringResource("string:request_unit_fixed_hours", "request_unit_fixed_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 240273, 120),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 341313, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219680, 108),
      ))
    }

@delegate:ResourceContentHash(-1_781_259_011)
public val Res.string.request_unit_hours: StringResource by lazy {
      StringResource("string:request_unit_hours", "request_unit_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 240394, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 341474, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219789, 54),
      ))
    }

@delegate:ResourceContentHash(19_911_648)
public val Res.string.request_unit_note: StringResource by lazy {
      StringResource("string:request_unit_note", "request_unit_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 240457, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 341549, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219844, 97),
      ))
    }

@delegate:ResourceContentHash(52_483_481)
public val Res.string.request_unit_title: StringResource by lazy {
      StringResource("string:request_unit_title", "request_unit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 240539, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 341679, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219942, 50),
      ))
    }

@delegate:ResourceContentHash(457_207_109)
public val Res.string.requests_absence_approved: StringResource by lazy {
      StringResource("string:requests_absence_approved", "requests_absence_approved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 240594, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 341754, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219993, 57),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString29Resources(map: MutableMap<String, StringResource>) {
  map.put("report_col_day", Res.string.report_col_day)
  map.put("report_col_hours", Res.string.report_col_hours)
  map.put("report_col_manager_signature", Res.string.report_col_manager_signature)
  map.put("report_col_night", Res.string.report_col_night)
  map.put("report_col_notes", Res.string.report_col_notes)
  map.put("report_col_planned", Res.string.report_col_planned)
  map.put("report_contract", Res.string.report_contract)
  map.put("report_employee", Res.string.report_employee)
  map.put("report_employer", Res.string.report_employer)
  map.put("report_generated", Res.string.report_generated)
  map.put("report_holiday", Res.string.report_holiday)
  map.put("report_hours_worked", Res.string.report_hours_worked)
  map.put("report_month", Res.string.report_month)
  map.put("report_night_hours", Res.string.report_night_hours)
  map.put("report_norm", Res.string.report_norm)
  map.put("report_payroll_title", Res.string.report_payroll_title)
  map.put("report_payslip_title", Res.string.report_payslip_title)
  map.put("report_plan_vs_actual", Res.string.report_plan_vs_actual)
  map.put("report_planned_only", Res.string.report_planned_only)
  map.put("report_role", Res.string.report_role)
  map.put("report_rounding_nearest", Res.string.report_rounding_nearest)
  map.put("report_rounding_note", Res.string.report_rounding_note)
  map.put("report_rounding_start_down_end_up", Res.string.report_rounding_start_down_end_up)
  map.put("report_rounding_start_up_end_down", Res.string.report_rounding_start_up_end_down)
  map.put("report_sign_employee", Res.string.report_sign_employee)
  map.put("report_sign_employer", Res.string.report_sign_employer)
  map.put("report_sunday", Res.string.report_sunday)
  map.put("report_sunday_holiday_hours", Res.string.report_sunday_holiday_hours)
  map.put("report_total", Res.string.report_total)
  map.put("report_total_hours", Res.string.report_total_hours)
  map.put("report_working_time_title", Res.string.report_working_time_title)
  map.put("report_workplace", Res.string.report_workplace)
  map.put("request_approve_now", Res.string.request_approve_now)
  map.put("request_blocks_no", Res.string.request_blocks_no)
  map.put("request_blocks_no_for", Res.string.request_blocks_no_for)
  map.put("request_blood_date", Res.string.request_blood_date)
  map.put("request_choose_type", Res.string.request_choose_type)
  map.put("request_date", Res.string.request_date)
  map.put("request_end_time", Res.string.request_end_time)
  map.put("request_for_person", Res.string.request_for_person)
  map.put("request_group_family", Res.string.request_group_family)
  map.put("request_group_health", Res.string.request_group_health)
  map.put("request_group_leave", Res.string.request_group_leave)
  map.put("request_group_work", Res.string.request_group_work)
  map.put("request_hours_value", Res.string.request_hours_value)
  map.put("request_limit_blood", Res.string.request_limit_blood)
  map.put("request_limit_days_year", Res.string.request_limit_days_year)
  map.put("request_limit_hours_year", Res.string.request_limit_hours_year)
  map.put("request_limit_less", Res.string.request_limit_less)
  map.put("request_limit_more", Res.string.request_limit_more)
  map.put("request_not_offered", Res.string.request_not_offered)
  map.put("request_not_offered_for", Res.string.request_not_offered_for)
  map.put("request_others", Res.string.request_others)
  map.put("request_part_of_day", Res.string.request_part_of_day)
  map.put("request_pay_employer", Res.string.request_pay_employer)
  map.put("request_pay_employer_half", Res.string.request_pay_employer_half)
  map.put("request_pay_none", Res.string.request_pay_none)
  map.put("request_pay_overtime", Res.string.request_pay_overtime)
  map.put("request_pay_sick", Res.string.request_pay_sick)
  map.put("request_pay_work", Res.string.request_pay_work)
  map.put("request_pay_zus", Res.string.request_pay_zus)
  map.put("request_place_label", Res.string.request_place_label)
  map.put("request_place_optional", Res.string.request_place_optional)
  map.put("request_popular", Res.string.request_popular)
  map.put("request_short_half", Res.string.request_short_half)
  map.put("request_short_line", Res.string.request_short_line)
  map.put("request_short_unpaid", Res.string.request_short_unpaid)
  map.put("request_short_zus", Res.string.request_short_zus)
  map.put("request_start_time", Res.string.request_start_time)
  map.put("request_type_available_for", Res.string.request_type_available_for)
  map.put("request_type_contracts_none", Res.string.request_type_contracts_none)
  map.put("request_type_enabled", Res.string.request_type_enabled)
  map.put("request_type_limits", Res.string.request_type_limits)
  map.put("request_type_open", Res.string.request_type_open)
  map.put("request_type_own_contracts", Res.string.request_type_own_contracts)
  map.put("request_type_pay", Res.string.request_type_pay)
  map.put("request_types_all_contracts", Res.string.request_types_all_contracts)
  map.put("request_types_dialog_hint", Res.string.request_types_dialog_hint)
  map.put("request_types_for", Res.string.request_types_for)
  map.put("request_types_group_labour_code", Res.string.request_types_group_labour_code)
  map.put("request_types_group_occasions", Res.string.request_types_group_occasions)
  map.put("request_types_group_sickness", Res.string.request_types_group_sickness)
  map.put("request_types_group_unpaid", Res.string.request_types_group_unpaid)
  map.put("request_types_more", Res.string.request_types_more)
  map.put("request_types_no_contract", Res.string.request_types_no_contract)
  map.put("request_types_none_on", Res.string.request_types_none_on)
  map.put("request_types_restore", Res.string.request_types_restore)
  map.put("request_types_restore_text", Res.string.request_types_restore_text)
  map.put("request_types_restore_title", Res.string.request_types_restore_title)
  map.put("request_types_state", Res.string.request_types_state)
  map.put("request_types_state_custom", Res.string.request_types_state_custom)
  map.put("request_types_state_legacy", Res.string.request_types_state_legacy)
  map.put("request_types_state_recommended", Res.string.request_types_state_recommended)
  map.put("request_unit_days", Res.string.request_unit_days)
  map.put("request_unit_fixed_days", Res.string.request_unit_fixed_days)
  map.put("request_unit_fixed_hours", Res.string.request_unit_fixed_hours)
  map.put("request_unit_hours", Res.string.request_unit_hours)
  map.put("request_unit_note", Res.string.request_unit_note)
  map.put("request_unit_title", Res.string.request_unit_title)
  map.put("requests_absence_approved", Res.string.requests_absence_approved)
}
